//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDelReceiveLines', {
//        templateUrl: 'views/components/views/batchDelReceiveLines/batchDelReceiveLines.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stateService', 'rememberService', 'batchDelReceiveLinesService', function ($stateParams, utilityService, stateService, rememberService, batchDelReceiveLinesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDeliveryKeyno = $stateParams.batchdelivery_keyno;
//            let purchInternalNo = $stateParams.purch_internal_no;
//            let purchLineKeyno = $stateParams.purchline_keyno;
//            let prodSizeColliKeyno = $stateParams.prodsizecolli_keyno;
//            let stockLocationKeyno = $stateParams.stocklocation_keyno;
//            let controlled = $stateParams.controlled;
//            let placed = $stateParams.placed;

//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                itemsListReceiveLines: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await batchDelReceiveLinesService.getSetting({
//                    batchdelivery_keyno: batchDeliveryKeyno,
//                    purch_internal_no: purchInternalNo,
//                    purchline_keyno: purchLineKeyno,
//                    prodsizecolli_keyno: prodSizeColliKeyno,
//                    stocklocation_keyno: stockLocationKeyno,
//                    controlled: controlled,
//                    placed: placed
//                }))[0];
//            }

//            async function loadReceiveLines() {
//                if (utilityService.validateParmsValue(vm.model.setting.batchdelivery_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                vm.model.itemsListReceiveLines = await batchDelReceiveLinesService.listReceiveLines(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case '':
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadReceiveLines();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
